<template>
  <div class="chargeback-statistics">
    <CRow>
      <CCol sm="6" lg="3">
        <CCard class="mb-3">
          <CCardBody class="p-3">
            <div class="text-muted small text-uppercase mb-1">
              <translate translate-context="chargeback.statistics">Count</translate>
            </div>
            <div class="h4 mb-0">{{ statistics.count || 0 }}</div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="6" lg="3">
        <CCard class="mb-3">
          <CCardBody class="p-3">
            <div class="text-muted small text-uppercase mb-1">
              <translate translate-context="chargeback.statistics">Chargeback Amount</translate>
            </div>
            <div class="h4 mb-0 text-danger">{{ formatAmount(statistics.total_chargeback_amount) }}</div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="6" lg="3">
        <CCard class="mb-3">
          <CCardBody class="p-3">
            <div class="text-muted small text-uppercase mb-1">
              <translate translate-context="chargeback.statistics">Dispute Fees</translate>
            </div>
            <div class="h4 mb-0 text-warning">{{ formatAmount(statistics.total_dispute_fee) }}</div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="6" lg="3">
        <CCard class="mb-3">
          <CCardBody class="p-3">
            <div class="text-muted small text-uppercase mb-1">
              <translate translate-context="chargeback.statistics">Total Loss</translate>
            </div>
            <div class="h4 mb-0 text-danger font-weight-bold">{{ formatAmount(statistics.total_loss) }}</div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
export default {
  name: 'ChargebackStatistics',
  props: {
    statistics: {
      type: Object,
      required: true
    }
  },
  computed: {
    currency() {
      return this.statistics.currency || 'EUR'
    }
  },
  methods: {
    formatAmount(amount) {
      const num = parseFloat(amount) || 0
      return `${num.toFixed(2)} ${this.currency}`
    },
  }
}
</script>
